import Vue from "vue";
import VueAnalytics from "vue-ua";
import { version } from "../package.json";
import App from "./components/App.vue";
import { setEnv } from "./utils/env";

require("./config").initialize(function (countryConfigs) {
	setEnv(countryConfigs);
	require("./components");
	require("./utils/filters");
	require("./utils/mixins");

	require("./router").initializeRoutes(function (router) {
		require("./utils/prototypes");

		let meta = {
			title: countryConfigs.websiteTitle,
			meta: [
				{
					name: "description",
					content: countryConfigs.websiteDescription,
				},
				{
					name: "keywords",
					content: countryConfigs.websiteKeywords,
				},
				{
					name: "apple-itunes-app",
					content: `app-id=${countryConfigs.iosAppId}, app-argument=${countryConfigs.mobileUrl}`,
				},
			],
		};

		if (process.env.NODE_ENV == "production") {
			Vue.use(VueAnalytics, {
				appName: "MOBILE_WEB",
				appVersion: version,
				trackingId: countryConfigs.gaID,
				debug: true,
				vueRouter: router,
			});
			meta = Object.assign({}, meta, {
				script: [
					{
						innerHTML: `
								(function (w, d, s, l, i) {
									w[l] = w[l] || [];
									w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
									var f = d.getElementsByTagName(s)[0],
										j = d.createElement(s),
										dl = l != "dataLayer" ? "&l=" + l : "";
									j.async = true;
									j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
									f.parentNode.insertBefore(j, f);
								})(
									window,
									document,
									"script",
									"dataLayer",
									"${countryConfigs.gtmID}"
								);
						`,
					},
				],
				noscript: [
					{
						innerHTML: `
								<iframe
									src="https://www.googletagmanager.com/ns.html?id=${countryConfigs.gtmID}"
									height="0"
									width="0"
									style="display: none; visibility: hidden"
								></iframe
							>
							`,
					},
				],
			});
		}

		console.log(meta);

		const app = new Vue({
			metaInfo() {
				return meta;
			},
			router,
			el: "#app",
			render: (h) => h(App),
		});
		window.betika = app;
	});
});
